export default "__VITE_ASSET__BMNggZiS__"